import api from './Api'

const route = '/cranes'

export default {
  get: params => api().get(`${route}`, { params: { ...params, expand: 'dealership' } }),
  view: params => api().get(`${route}/${params.id}`, { params }),
  viewDriverMov: params => api().get(`${route}/${params}`, { params }),
  post: (payload, params) => api().post(`${route}`, payload),
  put: (payload, params) => api().put(`${route}/${payload.id}`, payload),
  delete: payload => api().delete(`${route}/${payload.id}`),
  addImages: (id, payload) => api().post(`${route}/${id}/images`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data' // Indicar que es FormData
    }
  })
  // enable: payload => api().put(`${route}/enable/${payload.id}`),
  // getStats: () => api().get(`${route}/stats`)
}
